import React from "react";
import Button from "@material-ui/core/Button";
import { languages } from "../../constants/languages";
import PositiveIcon from "@material-ui/icons/ThumbUp";
import NegativeIcon from "@material-ui/icons/ThumbDown";

export const Votes = props => (
  <div
    style={{
      textAlign: "center",
      padding: 20,
      background: "#cad7df",
      borderRradius: "0px 0px 4px 4px"
    }}
  >
    <div style={{ fontWeight: 600 }}>{languages.features.howImportant}</div>
    <br />
    <div
      style={{
        display: "flex",
        justifyContent: "space-evenly",
        flexWrap: "wrap"
      }}
    >
      <Button
        variant="outlined"
        size="small"
        name="0"
        onClick={e => {
          props.handleVoteClick(e, "0");
        }}
        color={props.userVoted === "0" ? "secondary" : "main"}
      >
        <NegativeIcon style={{ height: 16, width: 16, marginRight: 5 }} />
        {languages.features.negative +
          (props.votesPerType["0"].length > 0
            ? " (" + props.votesPerType["0"].length + ")"
            : "")}
      </Button>
      <Button
        variant="outlined"
        size="small"
        name="1"
        onClick={e => {
          props.handleVoteClick(e, "1");
        }}
        color={props.userVoted === "1" ? "primary" : "default"}
        style={{
          color: props.userVoted === "1" ? "green" : "",
          borderColor: props.userVoted === "1" ? "green" : ""
        }}
      >
        <PositiveIcon style={{ height: 16, width: 16, marginRight: 5 }} />
        {languages.features.positive +
          (props.votesPerType["1"].length > 0
            ? " (" + props.votesPerType["1"].length + ")"
            : "")}
      </Button>
    </div>
  </div>
);
